export const environment = {
  production: true,
  env: 'prod',
  version: '2026.08.01.2',
  host: 'briteat.co.uk',
  supportPhone: '+44 7932 973156',
  supportEmail: undefined as string | undefined,
  companyName: undefined as string | undefined,
  fullAddress: undefined as string | undefined,
  firebase: {
    apiKey: "AIzaSyCpYJ2an51sE2vdR-ZkqOHDTcvZWFkBx64",
    authDomain: "brit-eat.firebaseapp.com",
    projectId: "brit-eat",
    storageBucket: "brit-eat.appspot.com",
    messagingSenderId: "224335422613",
    appId: "1:224335422613:web:d32f2981ae1f8d8ffea79c",
    measurementId: "G-W5NXK92T78"
  },
  vapidKey: 'BBhdbuFN-ZPKjpcTOKOeLZx_KR_UwrBY3vahVzoVAObFemIDdFNgGl4SF2RXMFqywVFdPJZlrI7ny_KjhFf0yMI' //from https://console.firebase.google.com/u/0/project/brit-eat/settings/cloudmessaging/web:OTA1MmY1NTYtZDc1Yi00MjgzLThlMmYtYTA5YzcxNmRjYTA5
};
